import styled from '@emotion/styled';
import { TableCell } from '@mui/material';

export const CustomCell = styled(TableCell)(({ typevariant }) => ({
  borderBottom: typevariant === 'secondary' ? 'unset' : 'inherit',
  ...(typevariant === 'secondary' && { border: `none !important` }),
}));
